module.exports = __webpack_public_path__ + "img/scope3.b21644ff.png";